import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireAvia } from "/home/runner/work/avia-js/avia-js/libs/player/dist/avia.cjs";
var aviaExports = requireAvia();
export { aviaExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(aviaExports);